import storage from '../../utils/storage'

const STORAGE_KEY = 'tr_v3_scoring_rules_real'
const STORAGE_KEY_MAP = 'tr_v3_scoring_rules_map_real'

const defaultRules = {
  lowMax: 4,
  mediumMax: 10,
  lowDesc: '低风险：0-4分',
  mediumDesc: '中风险：5-10分',
  highDesc: '高风险：≥11分'
}

export default {
  state: {
    rulesMap: { '1': { ...defaultRules } },
    rules: { ...defaultRules },
    defaultRules: { ...defaultRules }
  },
  mutations: {
    SET_SCORING_RULES(state, rules) {
      state.rules = rules
      storage.set(STORAGE_KEY, rules)
    },
    SET_RULES_FOR_TASK(state, { taskId, rules }) {
      const tid = String(taskId || '1')
      state.rulesMap[tid] = rules
      state.rules = rules
      storage.set(STORAGE_KEY_MAP, state.rulesMap)
      storage.set(STORAGE_KEY, rules)
    },
    LOAD_TASK_RULES(state, taskId) {
      const tid = String(taskId || '1')
      const taskRules = state.rulesMap[tid]
      if (taskRules) {
        state.rules = taskRules
      } else {
        const cloned = JSON.parse(JSON.stringify(state.defaultRules))
        state.rulesMap[tid] = cloned
        state.rules = cloned
        storage.set(STORAGE_KEY_MAP, state.rulesMap)
      }
    }
  },
  getters: {
    scoringRules: state => state.rules
  }
}
